import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withStyles, AppBar, Toolbar, Typography, Tooltip, Badge } from './../../../themes/default';
import { ExitToAppIcon, AppsIcon, NotificationsIcon } from './../../../themes/icons';
import { Buttons } from './../../../components/includes/container';
import { Image, Btn } from './../../../components/includes/ui';
import { UserService } from './../../../services';

import Apps from './../apps'
import Notifications from './../notifications'

import CONSTANT from './../../../config/constant';

const styles = theme => ({
  root:         {
                  zIndex: theme.zIndex.drawer + 1,
                  background: theme.palette.common.white,
                  boxShadow: theme.shadows[1],
                  borderBottom: `1px solid ${ theme.palette.grey[200] }`
                },
  columnLeft:   {  },
    brandImage: { width: 170, display: 'block' },
  columnCenter: { display: 'flex', flexGrow: 1, justifyContent: 'center' },
  columnRight:  { display: 'flex', alignItems: 'center' },
    salesforceStatus: { display: 'flex', alignItems: 'center', paddingRight: theme.spacing.unit * 2, marginRight: theme.spacing.unit * 2, borderRight: `1px solid ${ theme.palette.grey[200] }` },
      salesforceStatus__label: { marginRight: theme.spacing.unit }
});

class Header extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      submitAuth: false,
      appsAlert: false,
      notificationsAlert: false,
      notificationsTotal: 0
    };
  }

  componentDidMount() {}

  /*
  ** @Service
  ** @Description: Logout
  */

  handleSignOut = () => {

    UserService.signout().then((response) => {

      // @Dispatch
      this.props.Logout();

      // @Redirect
      this.props.history.push('/login');

    }).catch((error) => {

      console.log(error);

    });

  };

  /*
  ** @Click
  ** @Description: Cancel modal aplicaciones conectadas
  */

  handleToggleApps = (status) => {

    // @State
    this.setState({ appsAlert: status });

  }

  /*
  ** @Click
  ** @Description: Cancel modal notifications
  */

  handleToggleNotifications = (status) => {

    // @State
    this.setState({ notificationsAlert: status });

  }

  /*
  ** @Click
  ** @Description: Cancel modal notifications
  */

  handleMountNotifications = (data) => {

    // @State
    this.setState({ notificationsTotal: data.total });

  }

  render() {

    const site = CONSTANT.site;
    const header  = CONSTANT.header;
    const { appsAlert, notificationsAlert, notificationsTotal } = this.state;
    const { classes } = this.props;

    return(
      <React.Fragment>

        <AppBar position={ header.position } color={ header.color } className={ classes.root }>
          <Toolbar>
            <div className={ classes.columnLeft }>
              <Typography component="h1">
                <Typography component={ NavLink } to="/dashboard">
                  <Image src="assets/brand/hipotecario-seguros-cyan.png" alt={ site.name } className={ classes.brandImage }/>
                </Typography>
              </Typography>
            </div>
            <div className={ classes.columnCenter }>

            </div>
            <div className={ classes.columnRight }>
              <Buttons>
                <Tooltip title="Notificaciones">
                  <span>
                    <Btn color="secondary" loading={false} onClick={ () => { this.handleToggleNotifications(true) } }>
                      <Badge badgeContent={ notificationsTotal } color="primary">
                        <NotificationsIcon fontSize="small"/>
                      </Badge>
                    </Btn>
                  </span>
                </Tooltip>
                <Tooltip title="Aplicaciones conectadas">
                  <span>
                    <Btn color="secondary" loading={false} onClick={ () => { this.handleToggleApps(true) } }>
                      <AppsIcon fontSize="small"/>
                    </Btn>
                  </span>
                </Tooltip>
                <Tooltip title="Salir">
                  <span>
                    <Btn color="primary" loading={false} onClick={ this.handleSignOut }>
                      <ExitToAppIcon fontSize="small"/>
                    </Btn>
                  </span>
                </Tooltip>
              </Buttons>
            </div>
          </Toolbar>
        </AppBar>

        <Apps
          open={ appsAlert }
          onCancel={ () => { this.handleToggleApps(false) } }
        />

        <Notifications
          open={ notificationsAlert }
          onCancel={ () => { this.handleToggleNotifications(false) } }
          onMount={ (data) => { this.handleMountNotifications(data) } }
        />

      </React.Fragment>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    User: state.User
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    Logout: () => {
      dispatch({
        type: 'USER_REMOVE'
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Header));
